import React from 'react';
import { PdfLogoIcon } from '../../../../../utils/svg';

// Small mark-only logo shown in place of the full header + evaluator banner
// when the page is rendered for PDF export (see downloadPersonalisedPlanPdf.ts).
const PdfLogo: React.FC = () => (
  <div className="w-full flex items-center justify-center pt-[30px]">
    <PdfLogoIcon />
  </div>
);

export default PdfLogo;
